export const GET_ENGINEDATA_API_REQUEST = "GET_ENGINEDATA_API_REQUEST";
export const GET_ENGINEDATA_API_SUCCESS = "GET_ENGINEDATA_API_SUCCESS";
export const GET_ENGINEDATA_API_ERROR = "GET_ENGINEDATA_API_ERROR";
export const GET_LASTSYNCDATE_API_REQUEST = "GET_LASTSYNCDATE_API_REQUEST";
export const GET_LASTSYNCDATE_API_SUCCESS = "GET_LASTSYNCDATE_API_SUCCESS";
export const GET_LASTSYNCDATE_API_ERROR = "GET_LASTSYNCDATE_API_ERROR";

export const SYNC_DEALER_API_REQUEST = "SYNC_DEALER_API_REQUEST";
export const SYNC_DEALER_API_SUCCESS = "SYNC_DEALER_API_SUCCESS";
export const SYNC_DEALER_API_ERROR = "SYNC_DEALER_API_ERROR";

export const UNSYNC_DEALER_API_REQUEST = "UNSYNC_DEALER_API_REQUEST";
export const UNSYNC_DEALER_API_SUCCESS = "UNSYNC_DEALER_API_SUCCESS";
export const UNSYNC_DEALER_API_ERROR = "UNSYNC_DEALER_API_ERROR";

export const GET_DEALERCOUNTRY_API_REQUEST = "GET_DEALERCOUNTRY_API_REQUEST";
export const GET_DEALERCOUNTRY_API_SUCCESS = "GET_DEALERCOUNTRY_API_SUCCESS";
export const GET_DEALERCOUNTRY_API_ERROR = "GET_DEALERCOUNTRY_API_ERROR";

export const GET_COUNTRYSTATE_API_REQUEST = "GET_COUNTRYSTATE_API_REQUEST";
export const GET_COUNTRYSTATE_API_SUCCESS = "GET_COUNTRYSTATE_API_SUCCESS";
export const GET_COUNTRYSTATE_API_ERROR = "GET_COUNTRYSTATE_API_ERROR";